module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"filters":"Filtres","sort":"Trier"},"en":{"filters":"Filters","sort":"Sort by"},"de":{"filters":"Filter","sort":"Sortieren"},"es":{"filters":"Filtros","sort":"Filtrar"},"it":{"filters":"Filtri","sort":"sort"},"nl":{"filters":"Filteren","sort":"Sorteren"},"pt":{"filters":"Filtros","sort":"Filtrar"}}')
  delete Component.options._Ctor
}
